$dependencyManager.addDependencyCallback('plyr', () => {

  class VideoLoader {
    constructor() {
      
    }

    load(container, videoUrl, autoplay = false) {
      this.container = jQuery(container);
      this.videoUrl = videoUrl;
      this.autoplay = autoplay;

      // Initialize the video player
      return this.initPlayer();
    }

    initPlayer() {
      this.container.empty();

      let videoElement;
      const uniqueId = 'plyr-' + Math.random().toString(36).substr(2, 9);

      if (this.isVimeoUrl(this.videoUrl)) {
        // Create a Vimeo video element using jQuery
        videoElement = jQuery('<div>', {
          'id': uniqueId,
          'data-plyr-provider': 'vimeo',
          'data-plyr-embed-id': this.extractVimeoId(this.videoUrl)
        });
      } else if (this.isHlsUrl(this.videoUrl)) {
        // Create an HLS video element using jQuery
        videoElement = jQuery('<video>', {
          'id': uniqueId,
          controls: true,
          autoplay: this.autoplay,
          muted: this.autoplay
        });
      } else if (this.isMp4Url(this.videoUrl)) {
        // Create an MP4 video element using jQuery
        videoElement = jQuery('<video>', {
          'id': uniqueId,
          src: this.videoUrl,
          controls: true,
          autoplay: this.autoplay,
          muted: this.autoplay
        });
      } else {
        console.error('Unsupported video URL:', this.videoUrl);
        return Promise.reject('Unsupported video URL');
      }

      this.container.append(videoElement);

      return new Promise((resolve, reject) => {
        try {
          const playerOptions = {
            iconUrl: window.madPlyrIconUrl,
            storage: { enabled: false },
            autoplay: this.autoplay,
            muted: this.autoplay
          };
          
          // Setup HLS if needed
          if (this.isHlsUrl(this.videoUrl)) {
            if (window.Hls && Hls.isSupported()) {
              const hls = new Hls({
                maxBufferLength: 30,
                maxMaxBufferLength: 60,
                capLevelToPlayerSize: true,
                capLevelOnFPSDrop: true
              });
              
              hls.loadSource(this.videoUrl);
              hls.attachMedia(document.getElementById(uniqueId));
              
              // Optional: Handle HLS errors
              hls.on(Hls.Events.ERROR, (event, data) => {
                if (data.fatal) {
                  switch(data.type) {
                    case Hls.ErrorTypes.NETWORK_ERROR:
                      console.warn('HLS network error - trying to recover');
                      hls.startLoad();
                      break;
                    case Hls.ErrorTypes.MEDIA_ERROR:
                      console.warn('HLS media error - trying to recover');
                      hls.recoverMediaError();
                      break;
                    default:
                      console.error('Fatal HLS error, cannot recover');
                      hls.destroy();
                      reject(data);
                      break;
                  }
                }
              });
              
              // Store the HLS instance for later reference and cleanup
              this.hls = hls;
            } else if (document.getElementById(uniqueId).canPlayType('application/vnd.apple.mpegurl')) {
              // Use native HLS support if available (Safari, iOS)
              document.getElementById(uniqueId).src = this.videoUrl;
            } else {
              console.error('HLS is not supported in this browser and no fallback available');
              reject('HLS not supported');
              return;
            }
          }

          const player = new Plyr('#' + uniqueId, playerOptions);

          if (this.isVimeoUrl(this.videoUrl) && this.autoplay === true) {
            player.on('ready', () => {
              player.muted = true;
              player.play().catch(e => console.warn("Autoplay prevented:", e));
              resolve(player);
            });
            player.on('error', (event) => {
              console.error('Plyr Vimeo Error:', event);
              reject(event);
            });
          } else if ((this.isMp4Url(this.videoUrl) || this.isHlsUrl(this.videoUrl)) && this.autoplay === true) {
             player.on('ready', () => {
                player.muted = true;
                player.play().catch(e => console.warn("Autoplay prevented:", e));
                resolve(player);
             });
             player.on('error', (event) => {
               console.error('Plyr Video Error:', event);
               reject(event);
             });
          }
          else {
             player.on('ready', () => {
                resolve(player);
             });
             player.on('error', (event) => {
               console.error('Plyr Error:', event);
               reject(event);
             });
          }

          // Cleanup on destroy
          player.on('destroy', () => {
            if (this.hls) {
              this.hls.destroy();
              this.hls = null;
            }
          });

        } catch (error) {
            console.error('Error initializing Plyr:', error);
            // Clean up HLS if it was initialized
            if (this.hls) {
              this.hls.destroy();
              this.hls = null;
            }
            reject(error);
        }
      });
    }

    isVimeoUrl(url) {
      const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
      return vimeoRegex.test(url);
    }

    isMp4Url(url) {
      const mp4Regex = /\.mp4$/i;
      return mp4Regex.test(url);
    }
    
    isHlsUrl(url) {
      const hlsRegex = /\.m3u8(\?.*)?$/i;
      return hlsRegex.test(url);
    }

    extractVimeoId(url) {
      // Extract the Vimeo video ID from the URL
      const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
      const match = url.match(vimeoRegex);
      return match ? match[1] : null;
    }
  }

  // Expose the VideoLoader class globally
  window.VideoLoader = VideoLoader;

}, ['plyr', 'hls.js'], true);